//import 'ol/ol.css';
import * as toastr from "toastr";
import { FeatureType, ICAMSKey, IAPIResult, CloseFormEnum, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';
import * as AuthModel from '../Models/AuthModel';
import * as events from '../Bus/Bus';
import { ActivityListRequestModel, ActivityListType, ActivityListFilter } from '../Activity/Activity';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Entity_RouteCondition } from "../Route/Entity_RouteCondition";
import { Entity_PathStatements } from "./Entity_PathStatements";
import { UserDefinedFields } from "../UserDefinedFields/UserDefinedFields";
import { Entity_RouteAltRouteCodes } from "../Route/Entity_RouteAltRouteCodes";
import { Entity_PathChangePathCodes } from './Entity_PathChangePathCodes';
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Path {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private photos: Photos = new Photos();
    private routeCondition: Entity_RouteCondition = new Entity_RouteCondition();
    private Entity_PathStatements = new Entity_PathStatements();
    private Entity_RouteAltRouteCodes = new Entity_RouteAltRouteCodes();
    private Entity_PathChangePathCodes = new Entity_PathChangePathCodes();

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, protected authModel: AuthModel.IAuthModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openEditPanel = (data: ICAMSKey): void => {
        const self = this;

        // Check to see if the user has permissions, if not pop a toast
        if (self.authModel.policies.find(p => p == AuthModel.CAMSMap_CanEditRoute) == null) {
            toastr.error("You do not have rights to edit this type of record.");
            return;
        }

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Path/PathEdit', { routeCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Create Tables
            ($('#pathEditFurnitureTable') as any).bootstrapTable();
            ($('#pathEditIssuesTable') as any).bootstrapTable();
            ($('#pathEditLegalTable') as any).bootstrapTable();
            if ($('#pathEditHistoricTable')[0]) ($('#pathEditHistoricTable') as any).bootstrapTable();

            $('#pathEditActivityBtn').on('click', function () { self.showActivityInPopover($(this), data, $('#pathEditModal')); });

            // Show the form
            Utilities.GetModal('#pathEditModal', ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader('#pathEditModal');

            // Get extra table data
            self.GetPathLand(data);
            self.GetPathRoutes(data);
            self.GetPathFurniture(data);
            self.GetPathIssues(data);
            self.GetPathLegal(data);
            self.Entity_PathStatements.GetPathStatements(data);
            ($('#pathEditConditionTable') as any).bootstrapTable();

            // Get form validation
            Utilities.InitFormValidation($("#pathEditModal"));

            // RouteAltCodes
            $('#pathEditNewAltCodeBtn').on('click', function () {
                if (originalFormData !== $('#pathEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                    self.Entity_RouteAltRouteCodes.openRouteAltRouteCodesCreatePanel(data.code, function (r) {
                        events.bus.publish(events.eventOpenPathEditPanel(data)); // This re-opens the edit form which refreshes the Route form
                    });
                }
            });

            var table: any = ($('#pathEditAltCodesTable') as any).bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "Delete") {
                    self.Entity_RouteAltRouteCodes.deleteEntity(data, row.routeAltCodeType, row.code, function (r) {
                        if (r == true) {
                            Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                            events.bus.publish(events.eventOpenPathEditPanel(data));
                        }
                    });
                }
            });
            //open Infra EDit
            //$('#pathEditModal [data-historicid]').on('click', function () {
            var table: any = Utilities.GetControl('#pathEditHistoricTable');
            table.bootstrapTable(); 
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {               
                if (field == "infracode") {                    
                    var Uid = $element.data("historicid");
                    var historic: ICAMSKey = { code: Uid, featureType: FeatureType.InfraHistoric };
                    events.bus.publish(events.eventOpenInfraHistoricDetailsPanel([historic, function (result) {
                        self.openEditPanel(data);
                    }]));
                    Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                }                
            });

            // Bind buttons
            $('#pathEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                doSubmit().then(s => { if (s == true) Utilities.GetModal('#pathEditModal', ModalAction.Hide); });
            });

            function doSubmit() {
                return new Promise<boolean>(function (resolve, reject) {

                    // Validate
                    let form: any = $('#pathEditForm');
                    if (Utilities.CheckFormValidation(form)==false) return;

                    Utilities.BlockUI($("#pathEditModal .modal-content"));
                    let formData = new FormData(<any>$('#pathEditForm')[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/Path/UpdatePath',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                    UserDefinedFields.SaveUDFFieldsAtServer($('#pathEditForm'), '/Route/UpdatePathUserFields');

                                    resolve(true);
                                }
                                else {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });

                                    resolve(false);
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($("#pathEditModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                            resolve(false);
                        }
                    });
                });
            }

            // DELETE
            $('#pathEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(data);
            });

            // CANCEL
            $('#pathEditCancelBtn').on('click', function (evt) {
                if (originalFormData !== $('#pathEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                    });
                }
                else Utilities.GetModal('#pathEditModal', ModalAction.Hide);
            });


            // NEW ROUTE
            $('#pathEditNewRouteBtn').on('click', function () {
                Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                events.bus.publish(events.eventClearAllHighlights());
                events.bus.publish(events.eventResetAllPanels());
                events.bus.publish(events.eventRemoveAllMapInteractions());
                events.bus.publish(events.eventResetAllButtons(true));
                events.bus.publish(events.eventNewRouteWizardStart([data, true]));
            });

            // STATEMENTS
            $('#pathEditNewStatememntBtn').on('click', function () {
                self.Entity_PathStatements.openStatementCreatePanel(data, function (r) {
                    self.openEditPanel(data);
                });
                Utilities.GetModal('#pathEditModal', ModalAction.Hide);

            });

            // CONDITIONS
            var table: any = Utilities.GetControl('#pathEditConditionTable');
            table.bootstrapTable()
            //$('#pathEditConditionTable [data-routeconditionref]').on('click', function () {
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "id") {
                    var conditionData: ICAMSKey = $element.find("[data-routeconditionref]").data("routeconditionref");
                    self.routeCondition.openConditionEditPanel(conditionData, function () {
                        self.openEditPanel(data);
                    });
                    Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                }
                
            });
          
            $('#pathEditNewConditionBtn').on('click', function () {
                Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                self.routeCondition.openConditionCreatePanel(data, function () {
                    self.openEditPanel(data);
                }, true);
            });

            // PathChangeCode
            $('#pathEditChangeCodeBtn').on('click', function () {
                if (originalFormData !== $('#pathEditModal').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                    self.Entity_PathChangePathCodes.openPathChangePathCodePanel(data.code, function (r) {
                        if (r != null) {
                            events.bus.publish(events.eventRefreshMapLayer(null));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));
                            events.bus.publish(events.eventMapClosePopup());

                            var newData = data; newData.code = r;
                            events.bus.publish(events.eventOpenPathEditPanel(newData)); // This re-opens the edit form which refreshes the Path form
                        }
                    });
                }
            });

            // Save the original state of the edit form
            var originalFormData = $('#pathEditForm').serialize();

        });
    }

    public openDetailsPanel = (data: ICAMSKey): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Path/PathView', { routeCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#pathViewModal', ModalAction.Create);
            $('#pathViewActivityBtn').on('click', function () { self.showActivityInPopover($(this), data, null); });

            $('#editBtn').on("click", function () {
                events.bus.publish(events.eventOpenPathEditPanel(data));
                Utilities.GetModal('#pathViewModal', ModalAction.Hide);
            });

        });
    }

    public openCreatePanel = (): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Path/PathCreate', function (response, status, xhr) {
            var pathCodeStart = "";

            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#pathCreateModal', ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader('#pathCreateModal');

            // When the admin area changes, get a new path code
            $('#pathCreateModal [name="AdminArea"]').on('change', function () {
                var adminArea = <string>$(this).children("option:selected").val()
                self.GetSuggestedPathCode(adminArea, function (pathCode) {
                    $('#pathCreateModal [name="RouteCode"]').val(pathCode);
                    $('#pathCreateModal [name="RouteCodeReadOnly"]').val(pathCode);
                    $('#pathCreateModal [name="RouteNo"]').val(pathCode.split('/')[1]);
                    pathCodeStart = pathCode.split('/')[0];
                })
            });

            // Get form validation
            Utilities.InitFormValidation($("#pathCreateModal"));

            $("#pathCreateForm #RouteNo").on('input', function (event) {
                $('#pathCreateForm [name="RouteCodeReadOnly"]').val(pathCodeStart + "/" + $(this).val());
                $('#pathCreateForm [name="RouteCode"]').val(pathCodeStart + "/" + $(this).val());
            });

            $('#pathCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#pathCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#pathCreateModal .modal-content"));
                let formData = new FormData(<any>$('#pathCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Path/CreatePath',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#pathCreateModal', ModalAction.Hide);
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Route));
                                events.bus.publish(events.eventClearAllHighlights());
                                events.bus.publish(events.eventResetAllPanels());
                                events.bus.publish(events.eventRemoveAllMapInteractions());
                                events.bus.publish(events.eventResetAllButtons(true));

                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value +": "+ result.data.routeCode); });
                                // Create a new link on the newly created path
                                let data: ICAMSKey = { featureType: FeatureType.Path, code: result.data.routeCode };
                                events.bus.publish(events.eventNewRouteWizardStart([data, true]));
                            }
                            else {
                                if (result.message != null) toastr.error(result.message)
                                toastr.error('Failed to edit feature!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#pathCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#pathCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#pathCreateModal', ModalAction.Hide);
                self.cancel();
            });
        });
    }

    private cancel = (): void => {
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetPathRoutes = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Route/GetRoutesByPathCode";
        Utilities.BlockUI($('#pathEditRouteTable'));
        $.post(url, { routeCode: data.code },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#pathEditRouteTable'));
                try {
                    if (result.success == true) {
                        var table = ($('#pathEditRouteTable') as any);
                        table.bootstrapTable();
                        table.bootstrapTable('load', result.data);

                        // Add entity cklick events
                        //$('#pathEditModal [data-routeref]').on('click', function () {
                        table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                            if (field == "routeCode") {
                                var rdata: ICAMSKey = $element.find("[data-routeref]").data("routeref");
                                events.bus.publish(events.eventOpenRouteEditPanel(rdata));
                                Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                            }                            
                        });
                    }
                    else {
                        toastr.error('Failed to get route data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetPathLand = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Land/GetLandByPathCode";
        Utilities.BlockUI($('#pathEditLandTable'));
        $.post(url, { pathCode: data.code },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#pathEditLandTable'));
                try {
                    if (result.success == true) {
                        var table = ($('#pathEditLandTable') as any);
                        table.bootstrapTable();
                        table.bootstrapTable('load', result.data);

                        // Add entity cklick events
                        //$('#pathEditModal [data-landref]').on('click', function () {
                        table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                            if (field == "landCode") {
                                var ldata: ICAMSKey = $element.find("[data-landref]").data("landref");
                                events.bus.publish(events.eventOpenLandEditPanel(ldata));
                                Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                            }
                            
                        });
                    }
                    else {
                        toastr.error('Failed to get land data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetPathFurniture = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Infra/GetInfraByPathCode";
        Utilities.BlockUI($('#pathEditFurnitureTable'));
        $.post(url, { routeCode: data.code },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#pathEditFurnitureTable'));
                try {
                    if (result.success == true) {
                        var table = ($('#pathEditFurnitureTable') as any);
                        table.bootstrapTable();
                        table.bootstrapTable('load', result.data);

                        // Add entity cklick events
                        //$('#pathEditModal [data-infraref]').on('click', function () {
                        table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                            if (field == "infraCode") {
                                var infrdata: ICAMSKey = $element.find("[data-infraref]").data("infraref");
                                events.bus.publish(events.eventOpenInfraEditPanel([infrdata, function (result) {
                                    self.openEditPanel(data);
                                }]));
                                Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                            }                            
                        });
                    }
                    else {
                        toastr.error('Failed to get furniture data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetPathIssues = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Maint/GetMaintByPathCode";
        Utilities.BlockUI($('#pathEditIssuesTable'));
        $.post(url, { routeCode: data.code },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#pathEditIssuesTable'));
                try {
                    if (result.success == true) {
                        var table = ($('#pathEditIssuesTable') as any);
                        table.bootstrapTable();
                        table.bootstrapTable('load', result.data);

                        // Add entity cklick events
                        //$('#pathEditModal [data-maintref]').on('click', function () {
                        table.on('click-cell.bs.table', function (e, field, value, row, $element) {               
                            if (field == "maintCode") {                               
                                var idata: ICAMSKey = $element.find("[data-maintref]").data("maintref");
                                events.bus.publish(events.eventOpenMaintEditPanel(idata));
                                Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                            }
                            
                        });
                    }
                    else {
                        toastr.error('Failed to get issue data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetPathLegal = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Legal/GetLegalByPathCode";
        Utilities.BlockUI($('#pathEditLegalTable'));
        $.post(url, { pathCode: data.code },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#pathEditLegalTable'));
                try {
                    if (result.success == true) {
                        var table = ($('#pathEditLegalTable') as any);
                        table.bootstrapTable();
                        table.bootstrapTable('load', result.data);

                        // Add entity cklick events
                        //$('#pathEditModal [data-legalref]').on('click', function () {
                        table.on('click-cell.bs.table', function (e, field, value, row, $element) {  
                            if (field == "legalCode") {
                                var ldata: ICAMSKey = $element.find("[data-legalref]").data("legalref");
                                events.bus.publish(events.eventOpenLegalEventsEditPanel(ldata));
                                Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                            }                           
                        });
                    }
                    else {
                        toastr.error('Failed to get legal data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetSuggestedPathCode = (adminArea: string, callback: Function): void => {
        const self = this;

        let url = "/Path/SuggestNewPathCode";
        Utilities.BlockUI($('#pathCreateModal'));
        $.post(url, { adminArea: adminArea },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#pathCreateModal'));
                try {
                    if (result.success == true) {
                        callback(result.data);
                    }
                    else {
                        toastr.error('Failed to get suggested path code!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Path/DeletePath', data,
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Route));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));
                            Utilities.GetModal('#pathEditModal', ModalAction.Hide);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private showActivityInPopover = (el: JQuery<HTMLElement>, data: ICAMSKey, parentModal: JQuery<HTMLElement>): void => {
        let model: ActivityListRequestModel = { ID: data.code, ActivityListType: ActivityListType.PathActivity, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
        events.bus.publish(events.eventShowActivityList([el, model, parentModal]));
    }

}




